import React, {Component} from 'react';
import OrderCartAuthentication from "../../../ordercartauthentication/components/OrderCartAuthentication";
import LightBoxComponent from "../../lightbox/components/LightBoxComponent";
import LoginComponent from "../../Login/components/LoginComponent";
import "../style/HeaderStyle.scss";
import {Link} from "react-router-dom";



const RenderLightBox = props => {

    const { show, handleClick } = props;
    
    
    return (
        <LightBoxComponent isOpen={show} handleClick={handleClick} handleEventClose={handleClick}>
            <LoginComponent/>
        </LightBoxComponent>
    );
};

class HeaderComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showLightBox: false,
            cartCount: 0,
            orderCount: 0
        }
    }

    showLightBox() {
        this.setState({
            showLightBox: true
        });
    }

    closeLightBox() {
        this.setState({
            showLightBox: false
        });
    }

    openMenuMobile() {
        let menu = document.getElementById("navItems");
        menu.style.display = 'block';
    }

    render() {
        const userSeller = localStorage.getItem('user');

        return (
            <header id="Header">
                <div className="topHeader">
                    {window.localStorage.getItem("user_type") === "seller" &&
                        <div className="helloSeller">
                            Hello, <strong>{ userSeller }</strong>
                        </div>
                    }
                    <div className="MenuResponsive" id="MenuResponsive" onClick={() => this.openMenuMobile()}>
                        <span />
                        <span />
                        <span />
                    </div>
                    <h1 className="logo">
                        <Link to="/">
                            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo" />
                        </Link>
                    </h1>

                    <OrderCartAuthentication cartCount={this.state.cartCount} orderCount={this.state.orderCount} handleClick={ () => this.showLightBox()} />
                </div>

                { this.state.showLightBox &&
                    <RenderLightBox show={this.state.showLightBox} handleClick={ () => this.closeLightBox()} />
                }
            </header>
        );
    }
}

export default HeaderComponent;